import { render, staticRenderFns } from "./FiflboxNoticeList.vue?vue&type=template&id=89aa913e"
import script from "./FiflboxNoticeList.vue?vue&type=script&lang=js"
export * from "./FiflboxNoticeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports